import { useState } from 'react';
import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import { Field } from 'formik';
import { Upload, Button, Progress, message } from 'antd';
import styles from './style.module.scss';
import Status from '../../../../src/components/AccountSettings/TopQualities/status';
import { DEFAULT_FILE_SIZE, checkFileType } from 'utilites/utils';
import { getMediaLink } from 'store/actions/InventoryAction';
import { connect } from 'react-redux';

const MediaInput = ({
  name,
  label,
  isRequired,
  staticFileName,
  uploadButtonName = 'Click to Upload',
  maxFileSize = DEFAULT_FILE_SIZE,
  acceptFileType = '',
  isDisabled = false,
  getMediaLink,
  isFullWidth = false,
}) => {
  const [uploadedPercentage, setUploadedPercentage] = useState(0);
  const [fileName, setFileName] = useState('');

  const uploadImage = ({ onSuccess }) => {};

  const handleOnChange = ({ fileList }, setFieldValue, fieldName, setFieldError) => {
    const { size, originFileObj } = fileList[0] || {};
    setFileName(originFileObj?.name);

    if (!checkFileType(originFileObj?.type, acceptFileType)) {
      message.error('Invalid File Type');
      return;
    }

    if (size < maxFileSize) {
      getMediaLink({
        file: originFileObj,
        percent: setUploadedPercentage,
        setFieldValue,
        name,
      }).then((res) => {
        setFieldValue(fieldName, { ...fileList[0], ...res });
        setUploadedPercentage(0);
      });
    } else {
      setFieldError(fieldName, `Max file size should be less than ${maxFileSize / 1000} KB`);
    }
  };

  return (
    <Field name={name}>
      {({ field, meta: { error }, form: { setFieldValue, setFieldError } }) => (
        <div className={styles.uploadWrapper}>
          {label && (
            <p className={styles.label}>
              <span>{label}</span>
              {isRequired && <Status isFilled={!(field.value === null || error)} />}
            </p>
          )}
          <div className={isFullWidth ? styles['ant-upload-full-width'] : ''}>
            <Upload
              multiple={false}
              showUploadList={false}
              customRequest={uploadImage}
              accept={acceptFileType}
              onChange={(e) => handleOnChange(e, setFieldValue, field.name, setFieldError)}
              maxCount={1}
              listType="text"
              disabled={isDisabled}
              name={field.name}
              className={styles['upload-wrapper-fullwidth']}>
              {!field.value && uploadedPercentage < 1 && (
                <button
                  type="button"
                  className={`${styles['upload-button']} ${
                    isFullWidth ? '' : styles['upload-button-full-width']
                  }`}>
                  <span>
                    <UploadOutlined
                      className="icon-style"
                      style={{ fontSize: '18px', fontWeight: '600', color: '#1875e4' }}
                    />
                  </span>
                  <span className="upload-button-name">{uploadButtonName}</span>
                </button>
              )}
            </Upload>
          </div>

          <UploadFileDisplay
            field={field}
            fileName={fileName || staticFileName}
            setFieldValue={setFieldValue}
            uploadedPercentage={uploadedPercentage}
            setUploadedPercentage={setUploadedPercentage}
          />

          <div className={`${isFullWidth ? styles['error-margin-div'] : ''}`}>
            {error && <p className={styles.error}>{error}</p>}
          </div>
        </div>
      )}
    </Field>
  );
};

const UploadFileDisplay = ({
  field,
  fileName,
  setFieldValue,
  uploadedPercentage,
  setUploadedPercentage,
}) => {
  return field?.value ? (
    <div className={styles.downloadBox}>
      {typeof field.value === 'object' && (
        <div className={styles.textWrapperDownload}>
          <a href={field?.value?.fileUrl} download target="_blank" rel="noreferrer">
            {field?.value?.fileName}
          </a>
        </div>
      )}
      {typeof field.value === 'string' && (
        <a href={field.value} className={styles.textWrapperDownload} download>
          {fileName}
        </a>
      )}
      <Button
        style={{ border: 0 }}
        onClick={() => {
          setFieldValue(field.name, null);
          setUploadedPercentage(0);
        }}
        icon={<DeleteOutlined />}
      />
    </div>
  ) : uploadedPercentage ? (
    <div className={styles.downloadBox}>
      <div className={styles.textWrapperDownload}>{fileName}</div>
      <Progress width={30} type="circle" percent={uploadedPercentage} />
    </div>
  ) : null;
};

const mapStateToProps = (state) => ({
  materialData: state.fabricQualities.materialData,
});
const mapDispatchToProps = (dispatch) => ({
  getMediaLink: (data) => dispatch(getMediaLink(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MediaInput);
